// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3jOuo","headerContainer":"headerContainer___Ul1ES","title":"title___1QijE","btnContainer":"btnContainer___29Yf9","content":"content___1W_8f","renderResult":"renderResult___2H7R3","swatchReference":"swatchReference___3lAgO","orginalSwatch":"orginalSwatch___vL6P-","diffuseMap":"diffuseMap___3zNOc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RenderReview/RenderReview.module.css
// module id = 401
// module chunks = 0